import React from 'react'
import { Typography } from '@material-ui/core';
import { useIntl } from 'src/common/razzle-platform-translate'


function NoResults(props) {

    const { formatMessage } = useIntl()

    return (
        <div className="flex items-center h-64 flex-col">
            <div className="flex w-full justify-center text-center mt-24">
                <Typography className="text-3xl" variant="h6">{formatMessage({ id: "We're sorry!", defaultMessage: "We're sorry!" })}</Typography>
            </div>
            <div className="flex w-full justify-center text-center">
                <Typography className="text-2xl mt-4" variant="h4">{formatMessage({ id: "We couldn't find any results", defaultMessage: "We couldn't find any results" })}</Typography>
            </div>
        </div>
    )
}

export default NoResults
